/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Registration Field Input Validation:
 *   * `uri` - universal resource identifier (fully qualified url)
 *   * `phoneNumber` - phone number conforms to e.164 format: https://www.twilio.com/docs/glossary/what-e164
 *   * `email` - input text must be in "email_handle@domain" format
 *
 * @export
 */
export const RegistrationFieldInputValidation = {
    Uri: 'uri',
    PhoneNumber: 'phoneNumber',
    Email: 'email'
};
export function instanceOfRegistrationFieldInputValidation(value) {
    for (const key in RegistrationFieldInputValidation) {
        if (Object.prototype.hasOwnProperty.call(RegistrationFieldInputValidation, key)) {
            if (RegistrationFieldInputValidation[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function RegistrationFieldInputValidationFromJSON(json) {
    return RegistrationFieldInputValidationFromJSONTyped(json, false);
}
export function RegistrationFieldInputValidationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RegistrationFieldInputValidationToJSON(value) {
    return value;
}
